/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { SPACE_TYPES_WITH_UNIQUE_ACTIVITY } from "../constants";

const useCurrentSpaceTypeNameOfUniqueActivity = ({
	spaceTypeId, spaceTypeList
}) => {
	const [currentSpaceTypeNameOfUniqueActivity, setCurrentSpaceTypeNameOfUniqueActivity] = useState(null);
	useEffect(() => {
		if (!spaceTypeId || !SPACE_TYPES_WITH_UNIQUE_ACTIVITY.includes(spaceTypeId)) {
			setCurrentSpaceTypeNameOfUniqueActivity(null);
			return;
		}
		const spaceTypeFound = spaceTypeList.find(spaceType => spaceType.id === spaceTypeId);
		setCurrentSpaceTypeNameOfUniqueActivity(spaceTypeFound?.name || null);
	}, [spaceTypeId, spaceTypeList]);
	return currentSpaceTypeNameOfUniqueActivity;
}	
	
export default useCurrentSpaceTypeNameOfUniqueActivity;